/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Neobanq
 */
export class Neobanq {
    /**
     *
     * @type {string}
     * @memberof Neobanq
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Neobanq
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Neobanq
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Neobanq
     */
    apiKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Neobanq
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Neobanq
     */
    autoApprove: boolean;
}
